import Ls from '@/services/ls'
import * as types from './mutation-types'

export const login = ({ commit, dispatch, state }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('contact/login', data).then((response) => {
            const token = response.data.token
            Ls.set('auth.token', token)
            Ls.set('auth.pseudo', data.pseudo)
            commit(types.AUTH_SUCCESS, {token:token,pseudo:data.pseudo})
            resolve(response)
        }).catch(err => {
            Ls.remove('auth.token')
            Ls.remove('auth.pseudo')
            reject(err)
        })
    })
}
